import React, { useEffect, useState } from 'react'
import wallHeart from '../../../assets/images/icons/wall-heart.png'
import wallHeartFilled from '../../../assets/images/icons/wall-heart-filled.svg'
import profile from '../../../assets/images/profile.png'
import ForumServices from '@/services/forum-service'
import Pager from '@/components/atoms/pager/pager'
import userSessionStorage from '@/context/userSessionStorage'
import { forumId } from '@/constants/activity-constants'
import useUserLogged from '@/hooks/useUserLogged'
import { callModal } from '../modal-viewer/modal-viewer'
let lastTimeoutTorequest = -1
const skeletonInfo = {
  userFullName: 'cargando...',
  profilePhoto: profile,
  replyDate: 'cargando...',
  comment: 'cargando...',
  score: 0,
}
const configureHeaders = () => {
  const token = userSessionStorage.getToken()
  if (!token) return {}

  return {
    headers: {
      Authorization: token.idToken,
    },
  }
}

const getListCommentaries = (page, orderByLikes = false) =>
  ForumServices.getFormuPage(forumId, page, 3, orderByLikes, configureHeaders())
const doLogin = () => {
  return new Promise(resolve => {
    callModal('login', {
      forAccess: 'comentar en nuestro Wall of Love',
      onClose: logged => {
        resolve(logged)
      },
    })
  })
}
const LikeHeart = ({ comment, isLogged }) => {
  const [loading, setLoading] = useState(false)
  const likes = comment.score
  const liked = comment.likeByUser === 1
  const setLikes = num => {
    comment.score = num
  }
  const setLiked = newstate => {
    comment.likeByUser = newstate ? 1 : 0
  }
  const toggleLike = async () => {
    try {
      if (!isLogged) {
        if (!(await doLogin())) {
          return
        }
      }
      const config = configureHeaders()
      if (!config || loading) return

      setLoading(true)

      const newLikedState = !liked
      const { status } = await ForumServices.saveLikeByCommentId(
        comment.forumReplyId,
        newLikedState,
        config
      )

      if (status === 200) {
        setLikes(newLikedState ? likes + 1 : likes - 1)
        setLiked(newLikedState)
      }
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="interactions">
      <img
        onClick={toggleLike}
        src={liked ? wallHeartFilled : wallHeart}
        alt="wallHeart"
      />
      <p>{likes > 0 ? likes : ''}</p>
    </div>
  )
}

const timeAgo = dateParam => {
  const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam)
  const today = new Date()
  const seconds = Math.round((today - date) / 1000)
  const minutes = Math.round(seconds / 60)
  const hours = Math.round(minutes / 60)
  const days = Math.round(hours / 24)
  const weeks = Math.round(days / 7)
  const months = Math.round(days / 30)
  const years = Math.round(days / 365)

  if (seconds < 60) return `Hace ${seconds} segundos`
  else if (minutes < 60) return `Hace ${minutes} minutos`
  else if (hours < 24) return `Hace ${hours} horas`
  else if (days < 7) return `Hace ${days} días`
  else if (weeks < 5) return `Hace ${weeks} semanas`
  else if (months < 12) return `Hace ${months} meses`
  else return `Hace ${years} años`
}

const CardItem = ({ comment, isLogged }) => {
  return (
    <div className="f-forum-section-comments-card box">
      <div className="comment">
        <div className="user-info">
          <img
            className="user-info-image"
            src={comment?.profilePhoto || profile}
            alt="profile"
          />
          <div className="user-info-description">
            <p className="name">{comment?.userFullName || ''}</p>
            {comment && (
              <p className="date">{timeAgo(comment.replyDate) || ''}</p>
            )}
          </div>
        </div>
        <p>{comment?.comment || ''}</p>
      </div>
      {comment && <LikeHeart isLogged={isLogged} comment={comment} />}
    </div>
  )
}

const ForumList = ({ updateCounter, onUseToast }) => {
  const [isLogged] = useUserLogged()
  const [content, setContent] = React.useState({
    list: new Array(3).fill(skeletonInfo),
    page: 0,
    size: 3,
    total: 0,
  })

  const [orderByLikes, setOrderByLikes] = useState(true)
  const filters = [
    {
      label: 'Destacados',
      value: true,
    },
    {
      label: 'Más recientes',
      value: false,
    },
  ]

  const requestPage = page => {
    getListCommentaries(page, orderByLikes).then(resp => {
      if (resp.status === 200) {
        setContent({
          list: resp.data,
          page: resp.metadata.currentPage,
          size: resp.metadata.size,
          total: resp.metadata.limit,
        })
      } else {
        setContent({
          list: [null, null, null],
          page: 0,
          size: 3,
          total: 1,
        })
        console.warn(resp.userMessage)
      }
    })
  }
  const handleSetPage = page => {
    clearTimeout(lastTimeoutTorequest)
    lastTimeoutTorequest = setTimeout(() => {
      requestPage(page)
    }, 100)
  }
  useEffect(() => {
    handleSetPage(content.page)
  }, [updateCounter, isLogged])

  useEffect(() => {
    handleSetPage(0)
  }, [orderByLikes])

  useEffect(() => {
    handleSetPage(0)
  }, [])
  return (
    <>
      <div className="f-forum-section-comments">
        <div className="f-forum-section-filters">
          {filters.map((filter, index) => (
            <button
              key={index}
              onClick={() => {
                setOrderByLikes(filter.value)
              }}
              className={`f-forum-section-filters-button ${orderByLikes === filter.value ? 'active' : ''}`}
            >
              {filter.label}
            </button>
          ))}
        </div>
        {content.list.map((comment, index) => {
          return (
            <CardItem
              key={'card-item-' + comment?.forumReplyId + '-' + index}
              comment={comment}
              isLogged={isLogged}
            />
          )
        })}

        <Pager
          page={content.page}
          maxPages={content.total}
          onChangePage={handleSetPage}
        />
      </div>
    </>
  )
}

export default ForumList
